import { useKeycloak } from "@react-keycloak/web";
import { useState, useRef, useEffect } from 'react';
import { IoLogOutOutline } from 'react-icons/io5';
import { IoPersonOutline } from 'react-icons/io5';
import { IoCreateOutline } from 'react-icons/io5';
import { Avatar } from './Avatar';
import { getBadgeTailwindClasses } from '../styles/designSystem';
import { Link } from 'react-router-dom';

export const UserInfo = () => {
  const { keycloak } = useKeycloak();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    keycloak.logout({ redirectUri: window.location.origin });
  };

  // Get user info from Keycloak token
  const userInfo = keycloak.tokenParsed;
  const firstName = userInfo?.given_name || '';
  const lastName = userInfo?.family_name || '';
  const email = userInfo?.email || '';
  const fullName = userInfo?.name || `${firstName} ${lastName}`.trim() || 'User';
  const userId = userInfo?.sub || '';

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="h-10 w-10 rounded-xl bg-white border border-[rgba(112,115,147,0.16)] cursor-pointer transition-all hover:bg-[#F0F1F4] flex items-center justify-center"
      >
        <Avatar
          firstName={firstName}
          lastName={lastName}
          email={email}
          size={32}
        />
      </button>

      {isOpen && (
        <div className="absolute -right-[16px] mt-1 w-[280px] bg-white rounded-xl border-[0.5px] border-[rgba(112,115,147,0.16)] shadow-[0_2px_8px_rgba(0,0,0,0.05)] py-2 z-50">
                      <div className="px-4 py-2 text-gray-500">User Profile <span className={getBadgeTailwindClasses('dev')}>dev</span></div>
          
          <div className="px-4 py-2">
            <div className="flex items-center gap-3">
              <Avatar
                firstName={firstName}
                lastName={lastName}
                email={email}
                size={40}
              />
              <div>
                <div className="text-gray-900 font-medium font-['Arcadia_Text',system-ui,sans-serif]">{fullName}</div>
                <div className="text-gray-500 text-sm font-['Arcadia_Text',system-ui,sans-serif]">{email}</div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-100 mt-2">
            {userId && (
              <Link
                to={`/users/${userId}`}
                onClick={() => setIsOpen(false)}
                className="w-full px-4 py-2 text-left hover:bg-[#F0F1F4] flex items-center gap-3 text-gray-700"
              >
                <IoPersonOutline className="text-gray-500" />
                View Profile
              </Link>
            )}
            <Link
              to="/profile"
              onClick={() => setIsOpen(false)}
              className="w-full px-4 py-2 text-left hover:bg-[#F0F1F4] flex items-center gap-3 text-gray-700"
            >
              <IoCreateOutline className="text-gray-500" />
              Edit Profile
            </Link>
            <button
              onClick={handleLogout}
              className="w-full px-4 py-2 text-left hover:bg-[#F0F1F4] flex items-center gap-3 text-gray-700"
            >
              <IoLogOutOutline className="text-gray-500" />
              Log out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};